// Core
import React from 'react';
import { useQuery } from 'react-query';
import { Box, Button, Flex, Text, Grid, Divider, Image, useColorMode } from '@chakra-ui/react';

// Assets
import { apiService } from 'services/ApiService';

// Components
import { StarsIcon } from 'components/Icons/Icons';

const MembershipTermsConditions = () => {
  const { colorMode } = useColorMode();
  const isDark = colorMode === 'dark';

  const { data, isLoading } = useQuery({
    queryKey: ['membershipTermsConditions'],
    queryFn: async () => {
        const response = await apiService.getMembershipTermsConditions();
        return response.data;
    },
    refetchOnWindowFocus: false
  });

  return (
  	<Box m={{base: '-40px auto 100px auto', md: '37px auto 100px auto'}}>
  		<Flex gap={{base: '8px', md: '26px'}} m="82px 0 46px 0" w="100%" alignItems="center" textAlign="center" justifyContent="center">
      	<StarsIcon fontSize={{base: '28px', md: '43px'}} />
      	{ isDark && <Box bg="#099BFF"
          className="animation-opacity" 
      		filter="blur(40px)" w="50%" h="40px" left="50%" borderRadius="full"
      		transform="translate(-50%, 40px)" position="absolute" zIndex="-1" />}
      	<Text variant="header" fontSize={{base: '46px', md: '64px', lg: '72px'}}>Membership terms conditions</Text>
      	<StarsIcon fontSize={{base: '28px', md: '43px'}} />
      </Flex>

      <Box maxW="744px" m="0px auto" className="membership-terms-conditions">
    		{ !isLoading && data && (
  			   <Box dangerouslySetInnerHTML={{ __html: data?.content?.html }} />
    		)}
  		</Box>
  	</Box>
  );
};

export default MembershipTermsConditions;